import { render, staticRenderFns } from "./PriTama03.vue?vue&type=template&id=66e37c31&scoped=true&"
import script from "./PriTama03.vue?vue&type=script&lang=js&"
export * from "./PriTama03.vue?vue&type=script&lang=js&"
import style0 from "./PriTama03.vue?vue&type=style&index=0&id=66e37c31&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e37c31",
  null
  
)

export default component.exports